import type {ComponentType} from 'react';
import {WorkflowStartScreen, type WorkflowStartScreenProps} from './workflow';


export const startScreens: Record<
  string,
  ComponentType<WorkflowStartScreenProps>
> = {workflow: WorkflowStartScreen};
